import { jsx } from 'react/jsx-runtime';
import { d as EGDSLayoutTags } from '../types/index-chunk.esm2.js';

const EGDSLayout = (props) => {
    const { children, className, tag, domRef, ...attributes } = props;
    // Renders the custom Tag
    const Tag = ((tag && EGDSLayoutTags.get(tag)) || EGDSLayoutTags.get('div'));
    return children ? (jsx(Tag, { ref: domRef, className: className, ...attributes, children: children })) : null;
};

export { EGDSLayout as E };
//# sourceMappingURL=index-chunk.esm.js.map
